import React from 'react';
import { Box } from 'rebass';

/* INFO: Rebass doesn't support @emotion v11 yet https://github.com/rebassjs/rebass/pull/1051 */
/* TODO: remove default props and use variant "container" from theme when @emotion11 supported */
const Container = props => <Box {...props} variant="container" />;

Container.defaultProps = {
  mx: 'auto',
  px: 3,
  maxWidth: ['540px', '720px', '960px', '1140px'],
};

export default Container;
